<template>
  <div class="questions-view">
    <div class="mb-3">
      <a href="#"
         :class="{invisible: path.length === 0}"
         @click.prevent="path.pop()"
      >
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
        {{ $t('navigation.back') }}
      </a>
    </div>

    <div v-if="path.length < 1" class="intro mb-4 text-primary text-center small">
      {{ $t('questions.intro') }}
    </div>

    <div class="question text-primary font-weight-bold" style="min-height: 10em">{{ currentQuestion?.question }}</div>

    <div class="form-row justify-content-between">

      <div class="col-4">
        <button v-if="currentQuestion?.no"
                type="button"
                class="btn btn-block btn-outline-primary"
                @click="path.push('no')"
        >
          {{ $t('questions.answer.no') }}
        </button>
      </div>

      <div class="col-4">
        <button v-if="currentQuestion?.yes"
                type="button"
                class="btn btn-block btn-outline-primary"
                @click="path.push('yes')"
        >
          {{ $t('questions.answer.yes') }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>

import _get from "lodash/get"
import {mapMutations} from "vuex";

export default {
  name: 'Questions',
  data() {
    return {
      path: []
    }
  },
  watch: {
    path(nv) {
      this.$nextTick(() => {
        this.execAction()
        this.setQuestionPath(nv)
      })
    }
  },
  computed: {
    currentQuestion() {
      if (this.path.length === 0) {
        return this.$config.FORM
      }

      return _get(this.$config.FORM, this.path)
    }
  },
  created() {
    this.path = [...this.$store.state.questionPath]
    this.path.pop()
  },
  mounted () {
    if (!this.currentQuestion) {
      this.execNavigationAction('replace', '/online-appointment')
    }
  },
  methods: {

    ...mapMutations({
      setQuestionPath: "setQuestionPath"
    }),

    async execAction() {
      if (!this.currentQuestion?.actions) {
        // action is optional, if not set => skip
        return
      }

      for (const action of this.currentQuestion?.actions) {

        switch (action?.type) {
          case "navigation":
            await this.execNavigationAction(action?.options?.method, action?.options?.payload)
            break;
          case "commit":
            this.execCommitAction(action?.options?.mutation, action?.options?.payload)
            break;
          default:
            console.error(`passed action type "${action?.type}" is not supported`)
        }

      }

    },

    execNavigationAction(method, payload) {
      if (typeof this.$router[method] !== "function") {
        console.error("passed method does not exist", method, payload)
        return
      }
      return this.$router[method](payload)
    },

    execCommitAction(mutation, payload) {
      if (!mutation) {
        console.error("missing mutation type");
        return
      }
      this.$store.commit(mutation, payload)
    }
  }
}
</script>
